module.exports = __webpack_public_path__ + "static/media/landing-image-tablet.d98da32e.png";